import { localDateOf } from "@helmr/contracts";

/**
 * Calendar-date helpers on `YYYY-MM-DD` strings. Pure calendar arithmetic in UTC, so no timezone or DST can move a
 * date (CLAUDE.md rule 3); the instant → local date crossing is `localDateOf` from contracts and nothing else.
 */
export function addDays(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number) as [number, number, number];
  const at = new Date(Date.UTC(y, m - 1, d + days));
  return `${at.getUTCFullYear()}-${String(at.getUTCMonth() + 1).padStart(2, "0")}-${String(at.getUTCDate()).padStart(2, "0")}`;
}

export const today = (nowMs: number, timeZone: string) => localDateOf(nowMs, timeZone);

/** Minutes since local midnight for an instant, on the business wall clock. */
export function minutesOfDay(epochMs: number, timeZone: string): number {
  const parts = new Intl.DateTimeFormat("en-GB", { hour: "2-digit", minute: "2-digit", hourCycle: "h23", timeZone }).formatToParts(epochMs);
  const get = (t: string) => Number(parts.find((p) => p.type === t)?.value ?? 0);
  return get("hour") * 60 + get("minute");
}

export const hhmmToMinutes = (hhmm: string) => {
  const [h, m] = hhmm.split(":");
  return Number(h) * 60 + Number(m);
};
